import { Download, LockKeyhole } from "lucide-react";
import { useState } from "react";

export function LoginGate({ onUnlock }) {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);
  const isNativeApp = Boolean(window.Capacitor?.isNativePlatform?.());

  async function submit(event) {
    event.preventDefault();
    setWorking(true);
    setError("");
    try {
      await onUnlock(key);
    } catch (unlockError) {
      setError(unlockError.message);
    } finally {
      setWorking(false);
    }
  }

  return (
    <main className="login-gate">
      <div className="login-petals" aria-hidden="true"><i /><i /><i /><i /></div>
      <form onSubmit={submit}>
        <div className="login-brand">空の记忆<span>Memories of Sky</span></div>
        <LockKeyhole size={28} strokeWidth={1.1} aria-hidden="true" />
        <h1>这是一本私人相册</h1>
        <p>输入相册口令后，照片才会从私有存储中出现。</p>
        <label className="field">
          <span>相册口令</span>
          <input autoFocus type="password" value={key} onChange={(event) => setKey(event.target.value)} autoComplete="current-password" />
        </label>
        {error && <p className="error-message" role="alert">{error}</p>}
        <button className="primary-button" disabled={!key || working}>{working ? "正在解锁…" : "进入相册"}</button>
        {!isNativeApp && (
          <a className="login-download" href="/downloads/sky-memory-android.apk" download="sky-memory-android.apk">
            <Download size={16} strokeWidth={1.5} aria-hidden="true" />
            下载 Android APK
          </a>
        )}
      </form>
    </main>
  );
}
